import isSeatEqual from './isSeatEqual';

const deepContains = (array, element) => {
    return array.filter((a) => isSeatEqual(a, element)).length > 0;
};
export default deepContains;
